
import './styles/index.scss';

import TableHelper from './scripts/digital-publication-v2/TableHelper';
const tableHelper = new TableHelper();
tableHelper.setup();

import FootnoteHelper from './scripts/digital-publication-v2/FootnoteHelper';
const footnoteHelper = new FootnoteHelper();
footnoteHelper.setup();

import SearchHelper from './scripts/SearchHelper';
const searchHelper = new SearchHelper();
searchHelper.setup();

import AnchorHelper from "./scripts/digital-publication-v2/AnchorHelper";
const anchorHelper = new AnchorHelper();
anchorHelper.setup();

import App from './scripts/app';
const app = new App();
app.setup();

import Toc from './scripts/toc';
const toc = new Toc();
toc.setup();

import Head from './scripts/head';
const head = new Head();
head.setup();

import Menu from './scripts/menu';
const menu = new Menu();
menu.setup();

import Overlay from './scripts/overlay';
const overlay = new Overlay();
overlay.setup();

import SummaryPrintHelper from './scripts/SummaryPrintHelper';
const summaryPrintHelper = new SummaryPrintHelper();
summaryPrintHelper.setup();

// ----
// Listeners

const onMenuOpened = () => {
    app.menuOpened();
}

const onMenuClosed = () => {
    toc.resetExpansion()
    app.menuClosed();
}

toc.addListener('close', () => menu.close());
menu.addListener('closed', onMenuClosed);
menu.addListener('opened', onMenuOpened);
